'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BlueCaretArrowButton = require('./components/BlueCaretArrowButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlueCaretArrowButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/blue-caret-arrow/index.js
// module id = 1032
// module chunks = 1